/**
 * Central feature registry. To add a new feature:
 *   1. Run `scripts/new-feature.ps1 <name>` to scaffold the module.
 *   2. Import the new module here and add it to the `features` array.
 *
 * Order in the array is purely organizational; the sidebar uses
 * `feature.nav.order` to position items.
 */

import { aiModule } from "./ai";
import { aiConversationsModule } from "./ai_conversations";
import { billingMetricsModule } from "./billing_metrics";
import { chartsLabModule } from "./charts_lab";
import { codeBaseModule } from "./code_base";
import { commissionsModule } from "./commissions";
import { contractsModule } from "./contracts";
import { expansionModule } from "./expansion";
import { cosUnitsModule } from "./cos_units";
import { croForecastModule } from "./cro_forecast";
import { customerTiersModule } from "./customer_tiers";
import { dbExplorerModule } from "./db_explorer";
import { financialForecastModule } from "./financial_forecast";
import { glossaryModule } from "./glossary";
import { goalsModule } from "./goals";
import { integrationsModule } from "./integrations";
import { journeysModule } from "./journeys";
import { kpiModule } from "./kpi";
import { majorSwagModule } from "./major_swag";
import { missionModule } from "./mission";
import { objectivesModule } from "./objectives";
import { parentCompaniesModule } from "./parent_companies";
import { partnersModule } from "./partners";
import { planningModule } from "./planning";
import { posthogModule } from "./posthog";
import { pricingModule } from "./pricing";
import { proposalsModule } from "./proposals";
import { reconciliationModule } from "./reconciliation";
import { renewalsModule } from "./renewals";
import { reportsModule } from "./reports";
import { rolesModule } from "./roles";
import { sandboxModule } from "./sandbox";
import { settingsModule } from "./settings";
import type { FeatureModule } from "./types";
import { upsellOpsModule } from "./upsell_ops";
import { usersModule } from "./users";
import { whatsNewModule } from "./whats_new";
import { budgetVsActualModule } from "./budget_vs_actual";
import { cashFlowModule } from "./cash_flow";
import { whoamiModule } from "./whoami";
import { codeRagModule } from "./code_rag";
import { kbRagModule } from "./kb_rag";

export const features: FeatureModule[] = [
  whoamiModule,
  missionModule,
  kpiModule,
  renewalsModule,
  customerTiersModule,
  upsellOpsModule,
  expansionModule,
  contractsModule,
  commissionsModule,
  reconciliationModule,
  cosUnitsModule,
  majorSwagModule,
  partnersModule,
  parentCompaniesModule,
  integrationsModule,
  journeysModule,
  aiConversationsModule,
  codeBaseModule,
  codeRagModule,
  kbRagModule,
  aiModule,
  pricingModule,
  proposalsModule,
  objectivesModule,
  goalsModule,
  planningModule,
  croForecastModule,
  financialForecastModule,
  budgetVsActualModule,
  cashFlowModule,
  billingMetricsModule,
  sandboxModule,
  glossaryModule,
  whatsNewModule,
  usersModule,
  rolesModule,
  dbExplorerModule,
  chartsLabModule,
  reportsModule,
  settingsModule,
  posthogModule,
];
